import Info from './info';
import Stomp from './stomp';
export const info = new Info();
export const stomp = new Stomp();
export const transcribeStomp = new Stomp();

const webModels = {
  info,
  stomp,
  transcribeStomp,
};
(window as any).$cm = webModels;

export default webModels;
